import PropTypes from 'prop-types';
import React, { Component } from 'react';

const { bool, func, node, string } = PropTypes;

class TreeView extends Component
{
  static propTypes = {

    /**
     * labelWrapper is used to wrap the top-level folder with its associated
     * FolderItemDropTarget. This allows us to draw a drop border around
     * the folder and not its children when hovering over with a drag item.
     */
    labelWrapper: func.isRequired,
    collapsed: bool,
    defaultCollapsed: bool,
    nodeLabel: node.isRequired,
    className: string,
    itemClassName: string,
    arrow: node,
    children: node,
    onClick: func,
    handleOnMouseDown: func,
    indent: node,
    handleOnDoubleClick: func,
  }

  constructor(props) {
    super(props);
    this.state = { collapsed: props.defaultCollapsed };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ collapsed: !this.state.collapsed });
  }

  render() {
    const {
      collapsed = this.state.collapsed,
      className = '',
      itemClassName = '',
      nodeLabel,
      children,
      onClick,
      indent,
      handleOnMouseDown,
      handleOnDoubleClick,
      labelWrapper,
      ...rest,
    } = this.props;

    let arrowClassName = 'tree-view_arrow';
    let containerClassName = 'tree-view_children';
    if (collapsed) {
      arrowClassName += ' tree-view_arrow-collapsed';
      containerClassName += ' tree-view_children-collapsed';
    }

    const arrow = this.props.arrow || (
      <div
        {...rest}
        className={className + ' ' + arrowClassName}
        onClick={this.handleClick}
      />
    );

    return (
      <div className='tree-view' onClick={ onClick }>
        {labelWrapper((
          <div className={'tree-view_item ' + itemClassName}
            onMouseDown={handleOnMouseDown}
            onDoubleClick={handleOnDoubleClick}
          >
            { indent }
            {arrow}
            {nodeLabel}
          </div>
        ))}

        <div className={containerClassName}>
          {children}
        </div>
      </div>
    );
  }
}

export default TreeView;



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/Utilities/TreeView.js